// Utilitaires pour appliquer des tailles de texte dynamiques (depuis l'admin)
// avec un comportement responsive via CSS clamp().
//
// La valeur fournie par l'admin correspond à la TAILLE MAX (desktop).
// On garde une borne min raisonnable (mobile) pour ne jamais devenir illisible.

const clampNum = (n, min, max, fallback) => {
  const v = parseInt(n, 10);
  if (Number.isNaN(v)) return fallback;
  return Math.max(min, Math.min(max, v));
};

// Génère une valeur fontSize responsive: clamp(minPx, fluid, maxPx).
// fluid = scale linéaire en vw, calibré pour atteindre ~maxPx vers 1440px.
const fluid = (maxPx, minPx) => {
  // À 1440px de viewport, on veut ~maxPx ; à 360px on veut ~minPx.
  // vw value (slope) = (maxPx - minPx) / (1440 - 360) * 100 (in vw)
  const slope = ((maxPx - minPx) / (1440 - 360)) * 100;
  const base = minPx - (slope * 360) / 100; // offset
  const baseStr = `${base.toFixed(2)}px + ${slope.toFixed(3)}vw`;
  return `clamp(${minPx}px, calc(${baseStr}), ${maxPx}px)`;
};

export const sizeHeroTitle = (px) => {
  const max = clampNum(px, 40, 140, 80);
  return fluid(max, Math.max(34, Math.round(max * 0.5)));
};

export const sizeHeroSubtitle = (px) => {
  const max = clampNum(px, 14, 28, 18);
  return fluid(max, Math.max(14, max - 2));
};

export const sizeHeroLabel = (px) => {
  const v = clampNum(px, 10, 16, 11);
  return `${v}px`;
};

export const sizeSectionTitle = (px) => {
  const max = clampNum(px, 28, 80, 56);
  return fluid(max, Math.max(26, Math.round(max * 0.55)));
};

export const sizeSectionText = (px) => {
  const max = clampNum(px, 13, 22, 16);
  return fluid(max, Math.max(13, max - 2));
};

export const sizeNavbarLink = (px) => {
  const v = clampNum(px, 11, 18, 13);
  return `${v}px`;
};

export const sizeNavbarBtn = (px) => {
  const v = clampNum(px, 11, 18, 13);
  return `${v}px`;
};
